// Product images served from Shopify CDN
const CDN = "https://cdn.shopify.com/s/files/1/0720/8239/1175/files";

export type Product = {
  id: number;
  slug: string;
  name: string;
  tagline: string;
  category: string;
  categorySlug: string;
  price: number;
  subscriptionPrice: number;
  comparePrice: number | null;
  rating: number;
  reviewCount: number;
  badges: string[];
  images: string[];
  videoUrl?: string;
  accentClass: string;
  mechanismOfAction: string;
  clinicalBenefits: string[];
  dosage: string;
  dosingNotes: string;
  ingredients: { name: string; amount: string }[];
  relatedProductIds: number[];
  shopifyVariantId: string;
};

export const products: Product[] = [
  {
    id: 1,
    slug: "lions-mane-puro",
    name: "Lion's Mane Puro",
    tagline: "Enfoque & Cognición",
    category: "Enfoque & Cognición",
    categorySlug: "enfoque",
    price: 450,
    subscriptionPrice: 394,
    comparePrice: null,
    rating: 4.9,
    reviewCount: 5,
    badges: ["Más Vendido"],
    images: [
      `${CDN}/product-lionsmane-real.png?v=1770959261`,
      `${CDN}/product-lionsmane-back.png?v=1770959261`,
      "/images/lionsmane-gallery-1.png",
      "/images/lionsmane-gallery-2.png",
      "/images/lionsmane-gallery-3.png",
      "/images/lionsmane-gallery-4.png",
      "/images/lionsmane-gallery-5.png",
      "/images/lionsmane-gallery-6.png",
      "/images/lionsmane-gallery-7.png",
    ],
    accentClass: "bg-umbo-gold/10 text-umbo-gold",
    mechanismOfAction:
      "Lion's Mane (Hericium erinaceus) contiene compuestos bioactivos llamados hericenonas y erinacinas que cruzan la barrera hematoencefálica. Estos compuestos estimulan la síntesis del Factor de Crecimiento Nervioso (NGF), una proteína esencial para el crecimiento, mantenimiento y supervivencia de las neuronas. El NGF promueve la neurogénesis y la mielinización, mejorando la velocidad de transmisión sináptica y la plasticidad neuronal.",
    clinicalBenefits: [
      "Mejora significativa en memoria de trabajo y recall (estudio doble ciego, 2023)",
      "Estimula la producción de NGF para neurogénesis activa",
      "Reduce síntomas de ansiedad y depresión leve (escala HAM-A)",
      "Mejora la velocidad de procesamiento cognitivo en adultos 50+",
      "Efecto neuroprotector contra el deterioro cognitivo relacionado con la edad",
    ],
    dosage: "2 cápsulas al día (1000mg) con el desayuno",
    dosingNotes:
      "Los efectos cognitivos óptimos se observan a partir de las 4 semanas de uso constante. Puede tomarse con o sin alimentos. Compatible con café y otros nootrópicos.",
    ingredients: [
      { name: "Extracto de Lion's Mane (Hericium erinaceus)", amount: "500mg" },
      { name: "Beta-glucanos (estandarizado >30%)", amount: "150mg" },
      { name: "Hericenonas", amount: "12mg" },
      { name: "Erinacinas", amount: "8mg" },
      { name: "Vitamina B12 (metilcobalamina)", amount: "50mcg" },
    ],
    relatedProductIds: [2, 3],
    shopifyVariantId: "gid://shopify/ProductVariant/43894623076487",
  },
  {
    id: 2,
    slug: "cordyceps",
    name: "Cordyceps",
    tagline: "Energía & Rendimiento",
    category: "Energía & Rendimiento",
    categorySlug: "energia",
    price: 450,
    subscriptionPrice: 394,
    comparePrice: null,
    rating: 4.8,
    reviewCount: 4,
    badges: ["Nuevo"],
    images: [
      `${CDN}/product-cordyceps-real.png?v=1770959280`,
      `${CDN}/product-cordyceps-back.png?v=1770959280`,
      "/images/cordyceps-lifestyle-morning.png",
      "/images/cordyceps-ker-clinic.png",
      "/images/cordyceps-lifestyle-forest.png",
      "/images/cordyceps-gallery-1.png",
      "/images/cordyceps-gallery-2.png",
      "/images/cordyceps-gallery-3.png",
      "/images/cordyceps-gallery-4.png",
      "/images/cordyceps-gallery-5.png",
      "/images/cordyceps-gallery-6.png",
    ],
    accentClass: "bg-umbo-coral/10 text-umbo-coral",
    mechanismOfAction:
      "Cordyceps (Ophiocordyceps sinensis) actúa a nivel mitocondrial, aumentando la producción de ATP (adenosín trifosfato) — la molécula principal de energía celular. Además, incrementa la capacidad de captación de oxígeno (VO2 máx) al mejorar la eficiencia del intercambio gaseoso en los alvéolos pulmonares. También modula la producción de cortisol, proporcionando energía sostenida sin la respuesta de estrés asociada a estimulantes.",
    clinicalBenefits: [
      "Aumento del 7% en VO2 máx en atletas (estudio controlado, 12 semanas)",
      "Mejora en resistencia aeróbica y anaeróbica",
      "Incremento en producción de ATP mitocondrial",
      "Reducción de fatiga percibida durante ejercicio de alta intensidad",
      "Modulación del cortisol para energía sin crash",
    ],
    dosage: "2 cápsulas al día (1200mg) por la mañana",
    dosingNotes:
      "Mejor absorción en ayunas o con desayuno ligero. Ideal 30 min antes del ejercicio para máximo rendimiento. No tomar después de las 3pm para evitar interferencia con el sueño.",
    ingredients: [
      { name: "Extracto de Cordyceps (O. sinensis)", amount: "600mg" },
      { name: "Beta-glucanos (estandarizado >25%)", amount: "150mg" },
      { name: "Cordicepina", amount: "15mg" },
      { name: "Adenosina", amount: "5mg" },
      { name: "CoQ10", amount: "30mg" },
    ],
    relatedProductIds: [1, 4],
    shopifyVariantId: "gid://shopify/ProductVariant/43894624977031",
  },
  {
    id: 3,
    slug: "reishi-puro",
    name: "Reishi Puro",
    tagline: "Descanso & Recuperación",
    category: "Descanso & Recuperación",
    categorySlug: "descanso",
    price: 450,
    subscriptionPrice: 394,
    comparePrice: null,
    rating: 4.7,
    reviewCount: 4,
    badges: ["Vegano"],
    images: [
      `${CDN}/product-reishi-real.png?v=1770960030`,
      `${CDN}/product-reishi-back-real.png?v=1770960030`,
      "/images/reishi-ker-clinic.png",
      "/images/reishi-lifestyle-meditation.png",
      "/images/reishi-lifestyle-relaxing.png",
      `${CDN}/14.png?v=1772498728`,
      `${CDN}/15.png?v=1772498728`,
      `${CDN}/16.png?v=1772498728`,
      `${CDN}/17.png?v=1772498727`,
      `${CDN}/18.png?v=1772498728`,
      `${CDN}/19.png?v=1772498728`,
      `${CDN}/20.png?v=1772498728`,
    ],
    accentClass: "bg-umbo-indigo/10 text-umbo-indigo",
    mechanismOfAction:
      "Reishi (Ganoderma lucidum) contiene triterpenos (ácidos ganodéricos) que modulan el eje hipotálamo-pituitaria-adrenal (HPA), normalizando la producción de cortisol y GABA. Esto facilita la transición natural al sueño profundo (fase N3) y sueño REM. Adicionalmente, sus polisacáridos beta-glucanos ejercen un efecto inmunomodulador que reduce la inflamación crónica de bajo grado.",
    clinicalBenefits: [
      "Mejora en calidad del sueño (escala PSQI) en 4 semanas de uso",
      "Reducción de cortisol nocturno en un 18% (promedio)",
      "Aumento del tiempo en sueño profundo (fase N3)",
      "Efecto ansiolítico comparable a dosis bajas de ashwagandha",
      "Modulación inmunológica vía activación de células NK",
    ],
    dosage: "2 cápsulas (800mg) 1 hora antes de dormir",
    dosingNotes:
      "Para mejores resultados, tomar como parte de una rutina nocturna consistente. Puede combinarse con magnesio glicinato. Evitar cafeína 6 horas antes de la toma.",
    ingredients: [
      { name: "Extracto de Reishi (Ganoderma lucidum)", amount: "400mg" },
      { name: "Beta-glucanos (estandarizado >30%)", amount: "120mg" },
      { name: "Ácidos ganodéricos", amount: "20mg" },
      { name: "Triterpenos totales", amount: "8mg" },
      { name: "Magnesio glicinato", amount: "100mg" },
    ],
    relatedProductIds: [4, 1],
    shopifyVariantId: "gid://shopify/ProductVariant/43894634020999",
  },
  {
    id: 4,
    slug: "chaga-blend",
    name: "Chaga Blend",
    tagline: "Inmunidad & Digestión",
    category: "Inmunidad & Digestión",
    categorySlug: "inmunidad",
    price: 485,
    subscriptionPrice: 424,
    comparePrice: null,
    rating: 4.8,
    reviewCount: 3,
    badges: [],
    images: [
      `${CDN}/product-chaga-blend.png?v=1770960057`,
      `${CDN}/product-chaga-blend-back.png?v=1770960057`,
      "/images/chaga-blend-gallery-1.png",
      "/images/chaga-blend-gallery-2.png",
      "/images/chaga-blend-gallery-3.png",
      "/images/chaga-blend-gallery-4.png",
      "/images/chaga-blend-gallery-5.png",
    ],
    accentClass: "bg-emerald-500/10 text-emerald-600",
    mechanismOfAction:
      "Chaga Blend combina el hongo Chaga (Inonotus obliquus) con Cedrón, Toronjil y Galangal para crear una fórmula que une la potencia antioxidante del Chaga con plantas digestivas y calmantes de la herbolaria tradicional. El Chaga posee la mayor puntuación ORAC del reino fungi, mientras las hierbas complementan con acción carminativa y ansiolítica.",
    clinicalBenefits: [
      "Máxima capacidad antioxidante (ORAC) del reino fungi",
      "Soporte digestivo con Cedrón y Toronjil",
      "Propiedades antiinflamatorias del Galangal",
      "Activación de inmunidad innata y adaptativa",
      "Efecto calmante y equilibrante del sistema nervioso",
    ],
    dosage: "2 cápsulas al día (1.0g) con cualquier comida",
    dosingNotes:
      "Puede tomarse a cualquier hora del día con alimentos. Especialmente recomendado durante cambios de estación o periodos de estrés. Compatible con todos los demás productos Umbo.",
    ingredients: [
      { name: "Hongo Chaga (Inonotus obliquus)", amount: "250mg" },
      { name: "Hoja de Cedrón (Aloysia citrodora)", amount: "250mg" },
      { name: "Toronjil (Melissa officinalis)", amount: "250mg" },
      { name: "Galangal (Alpinia galanga)", amount: "250mg" },
    ],
    relatedProductIds: [3, 5],
    shopifyVariantId: "gid://shopify/ProductVariant/43894634250375",
  },
  {
    id: 5,
    slug: "mushroom-blend",
    name: "Mushroom Blend",
    tagline: "Bienestar Integral",
    category: "Bienestar Integral",
    categorySlug: "bienestar",
    price: 550,
    subscriptionPrice: 479,
    comparePrice: null,
    rating: 4.9,
    reviewCount: 5,
    badges: ["Más Popular"],
    images: [
      `${CDN}/product-mushroom-blend.png?v=1770960081`,
      `${CDN}/product-mushroom-blend-back.png?v=1770960081`,
      `${CDN}/34.png?v=1772498179`,
      `${CDN}/36.png?v=1772498178`,
      `${CDN}/35.png?v=1772498179`,
      `${CDN}/37.png?v=1772498179`,
      `${CDN}/38.png?v=1772498179`,
      "/images/mushroom-blend-lifestyle-woman.png",
      "/images/mushroom-blend-lifestyle-desk.jpg",
      "/images/mushroom-blend-lifestyle-cozy.jpg",
    ],
    accentClass: "bg-umbo-gold/10 text-umbo-gold",
    mechanismOfAction:
      "Mushroom Blend combina los cuatro hongos funcionales más estudiados — Melena de León, Reishi, Chaga y Cordyceps — en proporciones iguales (220.50mg cada uno). Esta sinergia activa múltiples vías biológicas simultáneamente: neurogénesis (NGF), producción de ATP mitocondrial, modulación del eje HPA y defensa antioxidante profunda. El efecto combinado supera la suma de sus partes individuales gracias al fenómeno de potenciación sinérgica entre beta-glucanos.",
    clinicalBenefits: [
      "Soporte cognitivo, energético, inmune y de descanso en una sola fórmula",
      "Sinergia de beta-glucanos de 4 especies para máxima biodisponibilidad",
      "Protección antioxidante de amplio espectro (ORAC elevado)",
      "Equilibrio adaptogénico que se ajusta a las necesidades del organismo",
      "Ideal como base diaria de suplementación funcional",
    ],
    dosage: "2 cápsulas al día (1.0g) con alimentos",
    dosingNotes:
      "Puede tomarse a cualquier hora del día con alimentos. Contiene Vitamina C (9mg) y Potasio (1.70mg) adicionales. Ideal para quienes buscan un protocolo simplificado con beneficios integrales.",
    ingredients: [
      { name: "Hongo Chaga (Inonotus obliquus)", amount: "220.50mg" },
      { name: "Hongo Cordyceps (O. sinensis)", amount: "220.50mg" },
      { name: "Hongo Melena de León (H. erinaceus)", amount: "220.50mg" },
      { name: "Hongo Reishi (G. lucidum)", amount: "220.50mg" },
      { name: "Vitamina C", amount: "9mg" },
    ],
    relatedProductIds: [1, 6],
    shopifyVariantId: "gid://shopify/ProductVariant/43894634283143",
  },
  {
    id: 6,
    slug: "reishi-blend",
    name: "Reishi Blend",
    tagline: "Calma & Digestión",
    category: "Calma & Digestión",
    categorySlug: "calma",
    price: 485,
    subscriptionPrice: 424,
    comparePrice: null,
    rating: 4.7,
    reviewCount: 3,
    badges: ["Nuevo"],
    images: [
      `${CDN}/product-reishi-blend.png?v=1770960103`,
      `${CDN}/product-reishi-blend-back.png?v=1770960103`,
      `${CDN}/21.png?v=1772497953`,
      `${CDN}/24.png?v=1772497953`,
      `${CDN}/22.png?v=1772497953`,
      `${CDN}/23.png?v=1772497953`,
      `${CDN}/25.png?v=1772497953`,
      `${CDN}/26.png?v=1772497954`,
      `${CDN}/27.png?v=1772497953`,
      "/images/reishi-blend-lifestyle-wellness.png",
      "/images/reishi-blend-lifestyle-meditation.png",
      "/images/reishi-blend-lifestyle-sleep.png",
      "/images/reishi-blend-lifestyle-nightstand.png",
      "/images/reishi-blend-gallery-1.png",
      "/images/reishi-blend-gallery-2.png",
      "/images/reishi-blend-gallery-3.png",
      "/images/reishi-blend-gallery-4.png",
      "/images/reishi-blend-gallery-5.png",
      "/images/reishi-blend-gallery-6.png",
      "/images/reishi-blend-gallery-7.png",
    ],
    accentClass: "bg-umbo-indigo/10 text-umbo-indigo",
    mechanismOfAction:
      "Reishi Blend combina el hongo Reishi con una selección de plantas adaptogénicas y digestivas de la herbolaria tradicional mexicana: Albahaca, Cedrón, Galanga, Zacate Limón y Toronjil. Esta fórmula actúa sobre el sistema nervioso entérico (el 'segundo cerebro') y el eje intestino-cerebro, promoviendo calma mental a través de la salud digestiva. Los compuestos carminativos y ansiolíticos naturales complementan la acción adaptogénica del Reishi.",
    clinicalBenefits: [
      "Reducción de estrés y ansiedad mediante acción sobre el eje intestino-cerebro",
      "Soporte digestivo con plantas carminativas tradicionales",
      "Efecto calmante del Toronjil y Cedrón sobre el sistema nervioso",
      "Propiedades antiinflamatorias de la Galanga y Zacate Limón",
      "Sinergia entre Reishi y hierbas adaptogénicas para equilibrio integral",
    ],
    dosage: "2 cápsulas al día (1.0g) preferentemente por la noche",
    dosingNotes:
      "Ideal tomar 1 hora antes de dormir como parte de la rutina nocturna. Las plantas digestivas ayudan a calmar el sistema gastrointestinal. Compatible con Reishi Puro para un protocolo de descanso potenciado.",
    ingredients: [
      { name: "Albahaca (Ocimum basilicum)", amount: "150mg" },
      { name: "Cedrón (Aloysia citrodora)", amount: "150mg" },
      { name: "Hongo Reishi (G. lucidum)", amount: "150mg" },
      { name: "Galanga (Alpinia galanga)", amount: "150mg" },
      { name: "Zacate Limón (Cymbopogon citratus)", amount: "150mg" },
      { name: "Toronjil (Melissa officinalis)", amount: "150mg" },
    ],
    relatedProductIds: [3, 5],
    shopifyVariantId: "gid://shopify/ProductVariant/43894634348679",
  },
  {
    id: 7,
    slug: "lions-mane-blend",
    name: "Lion's Mane Blend",
    tagline: "Enfoque & Vitalidad",
    category: "Enfoque & Vitalidad",
    categorySlug: "enfoque-vitalidad",
    price: 485,
    subscriptionPrice: 424,
    comparePrice: null,
    rating: 4.8,
    reviewCount: 4,
    badges: ["Nuevo"],
    images: [
      `${CDN}/product-lionsmane-blend.png?v=1770960121`,
      `${CDN}/product-lionsmane-blend-back.png?v=1770960121`,
      "/images/lionsmane-blend-lifestyle-1.png",
      "/images/lionsmane-blend-lifestyle-work.png",
      "/images/lionsmane-blend-gallery-1.png",
      "/images/lionsmane-blend-gallery-2.png",
      "/images/lionsmane-blend-gallery-3.png",
      "/images/lionsmane-blend-gallery-4.png",
      "/images/lionsmane-blend-gallery-5.png",
      "/images/lionsmane-blend-gallery-6.png",
    ],
    accentClass: "bg-umbo-gold/10 text-umbo-gold",
    mechanismOfAction:
      "Lion's Mane Blend potencia los efectos nootrópicos de la Melena de León con adaptógenos energizantes: Maca para vitalidad hormonal, Cacao para teobromina y flavonoides, Mucuna para precursores de dopamina (L-DOPA), y Ginseng para resistencia al estrés. Esta combinación actúa sobre múltiples neurotransmisores simultáneamente — NGF, dopamina, serotonina — creando un estado de enfoque motivado y sostenido.",
    clinicalBenefits: [
      "Neurogénesis potenciada por Lion's Mane + nootrópicos naturales",
      "Precursores de dopamina vía Mucuna pruriens (L-DOPA natural)",
      "Energía y vitalidad hormonal con Maca andina",
      "Teobromina del Cacao para estado de alerta sin ansiedad",
      "Resistencia al estrés cognitivo con Ginseng adaptogénico",
    ],
    dosage: "2 cápsulas al día (1.0g) por la mañana con alimentos",
    dosingNotes:
      "Mejor absorción con desayuno. La Mucuna y el Ginseng son estimulantes suaves, se recomienda tomar antes de las 2pm. Ideal para jornadas de trabajo intelectual intenso o estudio.",
    ingredients: [
      { name: "Hongo Melena de León (H. erinaceus)", amount: "200mg" },
      { name: "Maca (Lepidium meyenii)", amount: "200mg" },
      { name: "Cacao (Theobroma cacao)", amount: "200mg" },
      { name: "Mucuna (Mucuna pruriens)", amount: "200mg" },
      { name: "Ginseng (Panax ginseng)", amount: "200mg" },
    ],
    relatedProductIds: [1, 5],
    shopifyVariantId: "gid://shopify/ProductVariant/43894634381447",
  },
];

export function getProductBySlug(slug: string): Product | undefined {
  return products.find((p) => p.slug === slug);
}

export function getProductById(id: number): Product | undefined {
  return products.find((p) => p.id === id);
}
